import { RootState } from "app.store";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatMoney } from "../../shared/plugins/string-helper";
interface SummaryProps {
  subTotal: number;
  total: number;
  discount: number;
  shippingFee: number;
}
export const SummaryComponent = (props: SummaryProps) => {
  const { subTotal, total, discount, shippingFee } = props;
  const isAuthenticated = useSelector((state: RootState) => state.account.isAuthentication)
  return (
    <React.Fragment>
      <div className="info-container-inner">
        <div className="head p-bot-1 ">
          <span className="text-bold text-black">
            Thành tiền
          </span>
        </div>
        <div className="summary-container">
         <div className="item-summary m-bot-1">
            <h6 className="h5 name">Tạm tính:</h6>
            <h6 className="h5 price">{formatMoney(subTotal)}</h6>
          </div>
          <div className="item-summary m-bot-1">
            <h6 className="h5 name">Giảm giá:</h6>
            <h6 className="h5 price">{formatMoney(discount)}</h6>
          </div>
          <div className="item-summary m-bot-1">
            <h6 className="h5 name">Phí ship:</h6>
            <h6 className="h5 price">{formatMoney(shippingFee)}</h6>
          </div>
          <div className="total item-summary m-top-1 ">
              <h6 className="h5 name">Tông tiền:</h6>
              <h6 className="h5 price">{formatMoney(total)}</h6>
            </div>
        </div>
      </div>
      <div className="btn-container text-center">
        {isAuthenticated ? (
          <Link to={`/cart/address`} className="btn btn-primary text-uppercase">
          Tiến hành đặt hàng
          </Link>
        ) : (
          <a href={`/cart/address`} className="btn btn-primary text-uppercase">
          Tiến hành đặt hàng
          </a>
        )}
       
      </div>
    </React.Fragment>
  );
};
